import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "PaymentModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "PaymentModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content border-0 bg-transparent position-relative" }
const _hoisted_4 = { class: "modal-body bg-white rounded-3 p-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "fa-2x btn btn-primary btn-circle text-white b-modal-close",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bolder mb-5 text-center" }, "Payment", -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "fw-bold mb-0" }
const _hoisted_9 = { class: "fw-bold mb-0" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fa-2x me-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold mb-0" }, " New Payment Method", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "primary-gradient-bg bg-picado-img rounded-3 text-white p-3 py-4 d-flex my-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fa-2x me-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, " Your card will only be authorised for €0.01. In case of a no-show, your card will be charged an additional €15.00. ")
], -1)
const _hoisted_15 = { class: "text-center mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "modal-body bg-white rounded-3 p-4 new-method-dialog d-flex flex-column"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bolder mb-5 text-center" }, "New Payment Method", -1)
const _hoisted_20 = { class: "mt-auto" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "primary-gradient-bg bg-picado-img rounded-3 text-white p-3 py-4 d-flex my-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fa-2x me-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle" })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, " Your card will only be authorised for €0.01. In case of a no-show, your card will be charged an additional €15.00. ")
], -1)
const _hoisted_22 = { class: "text-center mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" Order ID " + _toDisplayString(_ctx.orderID) + " ", 1),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saved_cards, (card) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-4",
              key: card.id
            }, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["d-flex shadow-md p-4 rounded-3 align-items-center justify-content-between", _ctx.selected_card_id == card.id ? 'primary-gradient-bg text-white' : 'text-muted']),
                onClick: _withModifiers(($event: any) => (_ctx.selectCard(card)), ["prevent"])
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(card.masked_card), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(card.expiry_month) + "/" + _toDisplayString(card.expiry_year), 1)
              ], 10, _hoisted_7)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: "#",
              class: "d-flex shadow-md px-4 p-3 rounded-3 text-muted align-items-center",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addNewPayment()), ["prevent"]))
            }, _hoisted_13)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["btn rounded-5 px-4 fw-bold me-2", _ctx.payment_selected ? 'btn-primary' : 'btn-secondary opacity-50']),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.payNow()), ["prevent"]))
            }, " I Accept & Wish to proceed ", 2)
          ])
        ]),
        (_ctx.isNewMethod)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isNewMethod = false), ["prevent"])),
                class: "fa-2x btn btn-primary btn-circle text-white b-modal-close"
              }, _hoisted_18),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-primary rounded-5 px-4 fw-bold me-2",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.payNow()), ["prevent"]))
                  }, "I Accept & Wish to proceed")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}